
export class Member {
	[key: string]: string | string[] | number | boolean;

	mitgliedId = '';
	mitgliedsname = '';
	mitgliedsnummer = 0;


	// VORSITZENDE = CHAIRMAN
	vorsitzName = '';
	// vorsitzVorname = '';
	vorsitzStrasse = '';
	vorsitzOrt = '';
	vorsitzPLZ = '';
	vorsitzTelefon = '';
	vorsitzFax = '';
	// vorsitzEmail: "string",

	// GESCHÄFTSFÜHRER = MANAGING DIRECTOR
	gfName = '';
	// gfVorname": "string",
	gfStrasse = '';
	gfOrt = '';
	gfPLZ = '';
	// 	"gfEmail": "string",
	gfTelefon = '';
	gfFax = '';

	// GESCHÄFTSSTEL = BUSINESS PLACE
	gsStrasse = '';
	gsOrt = '';
	gsPLZ = '';
	gsTelefon = '';
	gsFax = '';
	gsWebAdesse = '';
	gsEmail = '';

	
	// bic = '';
	// iban = '';
	mitgliedLogo = '';
	region = '';

	kategorieIds: string[] = [];

	hauptansprechpartnerId = "";

}

// {
// 	"gdvMitgleid": "string",
// 	"kielerRueck": true,
// 	"mitgliedskuerzel": "string",
// 	"versisoft": true,
//   }



// MitgliedSparte
export class MemberSectionLink {
	mitgliedId = '';
	msId = '';
	sparteId = '';
	unassign = false;
}



